import { Add } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { ACTIVE_ROW_BACKGROUND } from "app/pages/sales-intelligence/pages/ai-agent/constants";
import { AttendeesLimitTooltip } from "app/pages/sales-intelligence/pages/ai-agent/components/AttendeesLimitTooltip/AttendeesLimitTooltip";
import { parseContactString } from "app/pages/sales-intelligence/pages/ai-agent/utils/contactUtils";

import { StyledAddNewAttendeeWrapper } from "./styles";

type Props = {
    search: string;
    isLimitReached: boolean;
    isActive: boolean;
    onClick: () => void;
    onHover: () => void;
};

export const AddNewAttendeeItem = ({ search, isLimitReached, isActive, onClick, onHover }: Props) => {
    const { name, title } = parseContactString(search);

    return (
        <StyledAddNewAttendeeWrapper>
            <AttendeesLimitTooltip isEnabled={isLimitReached}>
                <Flex
                    alignItems="center"
                    gap="12px"
                    padding="12px 16px"
                    cursor={isLimitReached ? "not-allowed" : "pointer"}
                    opacity={isLimitReached ? 0.5 : 1}
                    background={isActive ? ACTIVE_ROW_BACKGROUND : colorsPalettes.carbon[0]}
                    transition="background-color 250ms ease-in-out"
                    whenHover={isLimitReached ? undefined : { background: ACTIVE_ROW_BACKGROUND }}
                    role="option"
                    aria-selected={false}
                    aria-disabled={isLimitReached}
                    onClick={onClick}
                    onMouseEnter={onHover}
                    data-automation="ai-agent-attendees-add-new"
                >
                    <Add size="sm" />
                    <Stack>
                        <Text
                            fontVariant="input2"
                            color={colorsPalettes.black[0]}
                        >
                            {translate("si.pages.ai_agent.form.keyAttendees.button.add_named", {
                                name: name || search.trim(),
                            })}
                        </Text>
                        {title ? (
                            <Text
                                fontVariant="caption"
                                color={colorsPalettes.carbon[300]}
                            >
                                {title}
                            </Text>
                        ) : null}
                    </Stack>
                </Flex>
            </AttendeesLimitTooltip>
        </StyledAddNewAttendeeWrapper>
    );
};
